if (!customElements.get('xoa-gift-card')) {
  customElements.define(
    'xoa-gift-card',
    class XoaGiftCard extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.range = this.querySelector('[data-gift-card-range]');
        this.variantSelect = this.querySelector('.product-variant-id');
        this.priceOutput = this.querySelector('[data-gift-card-price]');
        this.visualPrice = this.querySelector('[data-gift-card-visual-price]');
        this.submitButton = this.querySelector('[data-gift-card-submit]');
        this.submitButtonText = this.submitButton?.querySelector('span');
        this.marks = [...this.querySelectorAll('[data-gift-card-mark]')];

        const variantsElement = this.querySelector('[data-gift-card-variants]');
        if (!this.range || !this.variantSelect || !this.submitButton || !variantsElement) return;

        try {
          this.variants = JSON.parse(variantsElement.textContent);
        } catch (error) {
          console.error('Lahjakortin varianttitietoja ei voitu lukea.', error);
          return;
        }

        if (!this.variants.length) return;

        this.initialized = true;
        this.classList.add('is-enhanced');
        this.range.addEventListener('input', () => this.updateVariant());
        this.range.addEventListener('change', () => this.updateVariant());

        this.updateVariant();
      }

      updateVariant() {
        const index = Math.max(0, Math.min(Number(this.range.value), this.variants.length - 1));
        const variant = this.variants[index];
        const progress = this.variants.length > 1 ? (index / (this.variants.length - 1)) * 100 : 0;

        this.range.style.setProperty('--gift-card-progress', `${progress}%`);
        this.range.setAttribute('aria-valuetext', variant.price);
        this.variantSelect.value = String(variant.id);
        this.variantSelect.disabled = !variant.available;

        if (this.priceOutput) this.priceOutput.textContent = variant.price;
        if (this.visualPrice) this.visualPrice.textContent = variant.price;

        this.marks.forEach((mark, markIndex) => {
          mark.classList.toggle('is-active', markIndex === index);
        });

        this.submitButton.disabled = !variant.available;
        if (!variant.available) {
          this.submitButton.setAttribute('aria-disabled', 'true');
        } else if (!this.submitButton.classList.contains('loading')) {
          this.submitButton.removeAttribute('aria-disabled');
        }

        if (this.submitButtonText) {
          this.submitButtonText.textContent = variant.available
            ? `${this.dataset.addLabel} – ${variant.price}`
            : this.dataset.soldOutLabel;
        }
      }
    }
  );
}
